{
  "satis_hedef_group": {
    "Baslik": "Sales Target Group Definitions",
    "Ad": "Group Name",
    "Birim": "Currency (TL/USD)",
    "UrunAta": "Assign Product",
    "UrunModeli Seç": "Select Product",
    "Urun Seç": "Select Product",
    "UrunAd": "Product Name",
    "FirmaAd": "Company Name",
    "Products": "Assigned Products",
    "Ara": "Search...",
    "Hepsi": "All",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Durum": "Status",
    "Duzenle": "Edit",
    "Yeni Ekle": "Add",
    "Filtrele": "Filter",
    "Temizle": "Clear",
    "Data Yenile": "Refresh Data",
    "ARA": "SEARCH",
    "Kapat": "Close",
    "Yenile": "Refresh",
    "Dolar": "USD",
    "TL": "TL",
    "Ekle": "Add",
    "Guncelle": "Update",
    "Kaydet": "Save",
    "Iptal": "Cancel",
    "Islem": "Action",
    "Urun yok": "No products assigned"
  }
}
